"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CenteredContainer_module_css_1 = __importDefault(require("./CenteredContainer.module.css"));
/**
 * A simple container that centers its child content
 */
function CenteredContainer({ children }) {
    return (0, jsx_runtime_1.jsx)("div", { className: CenteredContainer_module_css_1.default.centered, children: children });
}
exports.CenteredContainer = CenteredContainer;
//# sourceMappingURL=CenteredContainer.js.map